export type GreetingKey = "morning" | "afternoon" | "evening";

// hour of the viewer's local clock
export const greetingKeyForHour = (hour: number): GreetingKey => {
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 18) return "afternoon";
  return "evening";
};
